export default {
  title: '集體評分',
  paper: '試題',
  scoreStatus: '評分標準',
  table: {
    name: '姓名',
    number: '編號',
    score: '得分',
    average: '平均成績',
    class: '等級',
    comment: '評語',
    examScore: '考試成績',
    viewPaper: '查看考卷',
    noData: '暫無資訊',
    min: '最小值',
    max: '最大值',
    point: '{number}分',
    halfPoint: '半分',
    fullPoint: '滿分',
    setScore: '打分',
    edit: '編輯',
  },
  dialogTitle: '面試官評語',
  remarkPlaceholder: '請輸入內容',
  cancel: '取消',
  confirm: '確定',
  imagePreview: '圖片預覽',
  checkInTips: '該候選人尚未簽到,請先給該候選人簽到。',
  goCheckIn: '去給候選人簽到',
  checkInComment: '只評已簽到候選人',
  // checkStatusWaiting: "該候選人面試尚未開始",
  checkStatusWaiting: '您尚未開始評分，是否立即開始？',
  checkStatusComplete: '面試已結束,修改成績請返回列表頁點擊單個候選人修改',
  unscoredCandidate: '編號為 {number} 的候選人尚未打分，請打分後再提交。',
  error307: '您已被管理員結束打分,點擊確定後,將跳轉到首頁',
  noPaperAlert: {
    title: '提示',
    msg: '當前無有效試題！',
    expired: '原內容已失效,本次將打開新的內容,新內容有效時間為',
  },
  noPaper: '暫無試題',
  operateContent: {
    waiting: '開始評分',
    interviewing: '完成',
  },
  stateContent: {
    interviewing: '評分進行中',
    complete: '修改成績請返回列表頁點擊單個候選人修改',
  },
  exceedMaximumScore: '評分分值不符合預設分值。',
  viewQuestions: '查看試題',
  closeQuestions: '關閉試題',
  notDrawnPaper: '尚未抽題',
  scoreSheet: '評分表',
  questionsTab: '試題',
  noQuestions: '暫無試題',
  singleRating: '單人評分',
  groupRating: '集體評分',
  selectRatingMode: '選擇評分方式',
  candidateInfoTitle: '候選人資訊',
  candidateActions: '候選人操作',
  viewAttachment: '查看此附件',
  genderMale: '男',
  genderFemale: '女',
};
